import { useState, useEffect, useCallback } from 'react';
import { Modal } from '../components/ui';
import { api } from '../api';

function UserForm({ user, onClose, onSaved }) {
  const [form, setForm] = useState({ username: '', password: '', role: user?.role || 'user' });
  const [error, setError] = useState('');
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (user) {
        const body = { role: form.role };
        if (form.password) body.password = form.password;
        await api.updateUser(user.id, body);
      } else {
        await api.createUser(form);
      }
      onSaved();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Modal title={user ? `Modifier ${user.username}` : 'Nouvel utilisateur'} onClose={onClose}>
      <form onSubmit={submit} className="form-stack">
        {error && <div className="alert alert-error">⚠️ {error}</div>}
        {!user && (
          <div className="form-group">
            <label className="form-label">Identifiant</label>
            <input className="form-input" value={form.username} onChange={set('username')} autoComplete="off" required autoFocus />
          </div>
        )}
        <div className="form-group">
          <label className="form-label">{user ? 'Nouveau mot de passe (laisser vide pour ne pas changer)' : 'Mot de passe (6 caractères min.)'}</label>
          <input type="text" className="form-input" value={form.password} onChange={set('password')} autoComplete="off" minLength={6} required={!user} />
        </div>
        <div className="form-group">
          <label className="form-label">Rôle</label>
          <select className="form-select" value={form.role} onChange={set('role')}>
            <option value="user">Utilisateur</option>
            <option value="admin">Administrateur</option>
          </select>
        </div>
        <div className="form-actions">
          <button type="button" className="btn btn-secondary" onClick={onClose}>Annuler</button>
          <button className="btn btn-primary">Enregistrer</button>
        </div>
      </form>
    </Modal>
  );
}

export default function Users() {
  const [users, setUsers] = useState(null);
  const [editing, setEditing] = useState(null);
  const me = localStorage.getItem('muscuapp_user');

  const refresh = useCallback(() => api.getUsers().then(setUsers).catch((e) => alert(e.message)), []);
  useEffect(() => { refresh(); }, [refresh]);

  const toggleActive = async (u) => {
    try { await api.updateUser(u.id, { active: !u.active }); refresh(); } catch (e) { alert(e.message); }
  };
  const remove = async (u) => {
    if (!window.confirm(`Supprimer ${u.username} et toutes ses données (programmes, séances) ? Cette action est définitive.`)) return;
    try { await api.deleteUser(u.id); refresh(); } catch (e) { alert(e.message); }
  };

  if (!users) return <div className="spinner" />;

  return (
    <div>
      <div className="page-head">
        <div>
          <h1 className="page-title">Utilisateurs</h1>
          <p className="page-subtitle">Gère les comptes qui ont accès à l'application.</p>
        </div>
        <button className="btn btn-primary" onClick={() => setEditing({})}>＋ Nouvel utilisateur</button>
      </div>

      <div className="user-list">
        {users.map((u) => (
          <div key={u.id} className={'card user-row' + (u.active ? '' : ' user-row--off')}>
            <div className="user-row-main">
              <div className="user-avatar">{u.username.slice(0, 1).toUpperCase()}</div>
              <div>
                <div className="user-name">
                  {u.username}
                  {u.username === me && <span className="user-tag">toi</span>}
                  <span className={'user-tag' + (u.role === 'admin' ? ' user-tag--admin' : '')}>{u.role === 'admin' ? 'Admin' : 'Utilisateur'}</span>
                  {!u.active && <span className="user-tag user-tag--off">Désactivé</span>}
                </div>
                <div className="user-meta">{u.program_count} programme(s) · {u.session_count} séance(s)</div>
              </div>
            </div>
            <div className="user-actions">
              <button className="btn btn-secondary btn-sm" onClick={() => setEditing(u)}>✏️ Modifier</button>
              {u.username !== me && (
                <>
                  <button className="btn btn-ghost btn-sm" onClick={() => toggleActive(u)}>{u.active ? '⏸ Désactiver' : '▶ Réactiver'}</button>
                  <button className="btn btn-ghost btn-sm" onClick={() => remove(u)}>🗑️ Supprimer</button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <UserForm
          user={editing.id ? editing : null}
          onClose={() => setEditing(null)}
          onSaved={() => { setEditing(null); refresh(); }}
        />
      )}
    </div>
  );
}
